module.exports = __webpack_public_path__ + "static/media/04_insideyourblood.af0f4a50.jpg";